export default __webpack_public_path__ + "static/media/DBActive1.4ff03691.svg";